/**
 * Mentor register chips + leftover BusinessRegister labels — tuples [ko, en, vi, ru].
 */

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, v]) => {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  });
  return out;
}

const mentor = {
  regCatStartup: ['창업/스타트업', 'Startup', 'Khởi nghiệp', 'Стартап'],
  regCatBusiness: ['비즈니스', 'Business', 'Kinh doanh', 'Бизнес'],
  regCatMarketing: ['마케팅/SNS', 'Marketing / SNS', 'Marketing / MXH', 'Маркетинг / соцсети'],
  regCatRealestate: ['부동산/투자', 'Real estate / investing', 'BĐS / đầu tư', 'Недвижимость / инвестиции'],
  regCatLanguage: ['언어/교육', 'Language / education', 'Ngôn ngữ / giáo dục', 'Язык / образование'],
  regCatIt: ['IT/개발', 'IT / development', 'CNTT / lập trình', 'IT / разработка'],
  regCatDesign: ['디자인', 'Design', 'Thiết kế', 'Дизайн'],
  regCatFinance: ['재무/세무', 'Finance / tax', 'Tài chính / thuế', 'Финансы / налоги'],
  regCatLegal: ['법률/행정', 'Legal / admin', 'Pháp lý / hành chính', 'Право / администрация'],
  regCatCareer: ['취업/커리어', 'Jobs / career', 'Việc làm / sự nghiệp', 'Карьера'],
  regCatLifestyle: ['라이프스타일', 'Lifestyle', 'Phong cách sống', 'Образ жизни'],
  regCatOther: ['기타', 'Other', 'Khác', 'Другое'],
  consultVideo: ['화상 상담', 'Video consult', 'Tư vấn video', 'Видео-консультация'],
  consultChat: ['채팅 상담', 'Chat consult', 'Tư vấn chat', 'Чат-консультация'],
  consultInperson: ['대면 상담', 'In person', 'Gặp trực tiếp', 'Очно'],
  consultPhone: ['전화 상담', 'Phone consult', 'Tư vấn điện thoại', 'По телефону'],
  expPlan: ['사업계획서', 'Business plan', 'Kế hoạch KD', 'Бизнес-план'],
  expRaise: ['투자유치', 'Fundraising', 'Gọi vốn', 'Привлечение капитала'],
  expLocalize: ['현지화 전략', 'Localization', 'Chiến lược địa phương', 'Локализация'],
  expMkt: ['마케팅 전략', 'Marketing strategy', 'Chiến lược marketing', 'Маркетинг-стратегия'],
  expSns: ['SNS 운영', 'SNS operations', 'Vận hành MXH', 'Ведение соцсетей'],
  expContent: ['콘텐츠 제작', 'Content production', 'Sản xuất nội dung', 'Контент'],
  expRe: ['부동산 투자', 'Real-estate investing', 'Đầu tư BĐS', 'Инвестиции в недвижимость'],
  expTax: ['세금/회계', 'Tax / accounting', 'Thuế / kế toán', 'Налоги / учёт'],
  expVisa: ['비자/법률', 'Visa / legal', 'Visa / pháp lý', 'Виза / право'],
  expJob: ['취업 준비', 'Job prep', 'Chuẩn bị việc', 'Подготовка к работе'],
  expResume: ['이력서 첨삭', 'Resume review', 'Sửa CV', 'Правка резюме'],
  expInterview: ['인터뷰 코칭', 'Interview coaching', 'Luyện phỏng vấn', 'Коучинг собеседования'],
  expKo: ['한국어 교육', 'Korean teaching', 'Dạy tiếng Hàn', 'Корейский язык'],
  expVi: ['베트남어 교육', 'Vietnamese teaching', 'Dạy tiếng Việt', 'Вьетнамский язык'],
  expEn: ['영어 회화', 'English conversation', 'Giao tiếp tiếng Anh', 'Разговорный английский'],
  expCode: ['코딩 교육', 'Coding lessons', 'Dạy lập trình', 'Обучение коду'],
  expUx: ['UI/UX 디자인', 'UI/UX design', 'Thiết kế UI/UX', 'UI/UX'],
  expPhoto: ['사진/영상', 'Photo / video', 'Ảnh / video', 'Фото / видео'],
};

const businessRegister = {
  subFirstPrimary: [
    '해당 업종을 모두 선택하세요. 첫 선택이 대표 업종입니다.',
    'Select all that apply. The first selection is the primary type.',
    'Chọn tất cả ngành phù hợp. Lựa chọn đầu là ngành chính.',
    'Выберите все подходящие. Первый выбор — основной тип.',
  ],
  detailTags: ['세부 태그', 'Detail tags', 'Thẻ chi tiết', 'Теги'],
  tagsHintEnter: [
    '선택: 엔터로 직접 태그 추가 (최대 20개)',
    'Optional: add custom tags with Enter (max 20).',
    'Tuỳ chọn: Enter để thêm thẻ (tối đa 20).',
    'Необязательно: Enter — свой тег (до 20).',
  ],
  tagsPlaceholder: [
    '예: 오토바이보험, 한국어상담, 24시간',
    'e.g. 24h, Korean support',
    'VD: bảo hiểm xe, hỗ trợ tiếng Hàn, 24h',
    'напр. 24ч, корейский, страховка',
  ],
  serviceOptions: ['서비스 옵션', 'Service options', 'Tuỳ chọn dịch vụ', 'Опции услуг'],
  serviceOptionsHint: [
    '나중에 사용자 필터에서 노출할 옵션을 선택하세요.',
    'Select options customers can filter by later.',
    'Chọn tuỳ chọn sẽ hiện trong bộ lọc sau này.',
    'Выберите опции для фильтров клиентов.',
  ],
  gpsLabel: ['업체 위치 (GPS)', 'Business location (GPS)', 'Vị trí cửa hàng (GPS)', 'Место (GPS)'],
  latPlaceholder: ['위도 (예: 16.0544)', 'Latitude (e.g. 16.0544)', 'Vĩ độ (vd: 16.0544)', 'Широта (напр. 16.0544)'],
  lngPlaceholder: ['경도 (예: 108.2022)', 'Longitude (e.g. 108.2022)', 'Kinh độ (vd: 108.2022)', 'Долгота (напр. 108.2022)'],
};

function buildLang(i) {
  return {
    mentor: pick(mentor, i),
    businessRegister: pick(businessRegister, i),
  };
}

export const phaseMentorBusinessRegisterKo = buildLang(0);
export const phaseMentorBusinessRegisterEn = buildLang(1);
export const phaseMentorBusinessRegisterVi = buildLang(2);
export const phaseMentorBusinessRegisterRu = buildLang(3);
